import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconMusic = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--music")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M9,16.0002475 C9.55228475,16.0002475 10,16.4479627 10,17.0002475 L10,19.0002475 C10,20.6571017 8.65685425,22.0002475 7,22.0002475 L5,22.0002475 C3.34314575,22.0002475 2,20.6571017 2,19.0002475 C2,17.3433932 3.34314575,16.0002475 5,16.0002475 L9,16.0002475 Z M8,18.0002475 L5,18.0002475 C4.44771525,18.0002475 4,18.4479627 4,19.0002475 C4,19.5525322 4.44771525,20.0002475 5,20.0002475 L7,20.0002475 C7.55228475,20.0002475 8,19.5525322 8,19.0002475 L8,18.0002475 Z M22,17.0002475 C22,18.6571017 20.6568542,20.0002475 19,20.0002475 L17,20.0002475 C15.3431458,20.0002475 14,18.6571017 14,17.0002475 C14,15.3433932 15.3431458,14.0002475 17,14.0002475 L20,14 L20,4.18070789 L10,5.84737456 L10,17.0002475 C10,17.5525322 9.55228475,18.0002475 9,18.0002475 C8.44771525,18.0002475 8,17.5525322 8,17.0002475 L8,17.0002475 L8,5.00024747 C8,4.51140831 8.35341304,4.09421821 8.83560101,4.01385354 L8.83560101,4.01385354 L20.835601,2.01385354 C21.4451327,1.91226493 22,2.38230803 22,3.00024747 L22,3.00024747 L22,17.0002475 Z M20,16.0002475 L17,16.0002475 C16.4477153,16.0002475 16,16.4479627 16,17.0002475 C16,17.5525322 16.4477153,18.0002475 17,18.0002475 L19,18.0002475 C19.5522847,18.0002475 20,17.5525322 20,17.0002475 L20,16.0002475 Z" id="icon--centivo--music"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1169.000000, -860.000000)"/>
          <g id="Icon/music">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--music"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--music"/>
          </g>
      </g>
  </IconWrapper>
)
